/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rollback_ErrorInputs */

const vi_note_rollback_error = /** @type {(inputs: Note_Rollback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không rollback được phiếu, vui lòng thử lại`)
};

/**

* @param {Note_Rollback_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_error = /** @type {((inputs?: Note_Rollback_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_error(inputs)
});